<header class="header">
  <div class="header-left">
    <!-- <div class="search-box">
      <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"/>
        <line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input type="text" placeholder="Search product" [(ngModel)]="searchQuery" />
      <div class="search-shortcut">
        <span>K</span>
        <span>⌘</span>
      </div>
    </div> -->
  </div>

  <div class="header-right">
    <button class="header-icon-btn">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
      <span class="notification-dot" *ngIf="notificationCount > 0"></span>
    </button>

    <button class="header-icon-btn">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    </button>

    <div class="user-profile" (click)="toggleUserMenu()">
      <div class="user-info">
        <span class="user-name">{{ userName }}</span>
        <span class="user-role">{{ userRole }}</span>
      </div>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="6 9 12 15 18 9"/>
      </svg>

      <div class="user-menu" *ngIf="showUserMenu">
        
        <!-- Multiple Accounts Section -->
        <div class="accounts-section" *ngIf="accounts.length > 1">
          <div class="menu-label text-xs font-bold text-gray-400 uppercase tracking-wider px-4 py-2">Switch Account</div>
          <a class="user-menu-item account-item flex items-center gap-3 px-4 py-2 hover:bg-slate-50 cursor-pointer" 
             *ngFor="let acc of accounts" 
             (click)="switchAccount(acc.user.id)"
             [class.active-account]="acc.user.id === currentUserId"
             [ngStyle]="{'background-color': acc.user.id === currentUserId ? '#f8fafc' : 'transparent'}">
             <div class="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-bold flex-shrink-0">
                {{ (acc.user.name || 'U').substring(0,2).toUpperCase() }}
             </div>
             <div class="flex-1 overflow-hidden">
               <div class="text-sm font-medium text-gray-900 truncate">{{ acc.user.name }}</div>
               <div class="text-xs text-gray-500 truncate">{{ acc.user.email }}</div>
             </div>
             <svg *ngIf="acc.user.id === currentUserId" class="text-emerald-500 flex-shrink-0" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
               <polyline points="20 6 9 17 4 12"/>
             </svg>
          </a>
          <hr class="my-1 border-gray-100" />
        </div>

        <a class="user-menu-item" (click)="addAccount()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Add Account
        </a>
        <hr class="my-1 border-gray-100" />

        <a class="user-menu-item" routerLink="/profile" (click)="toggleUserMenu()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          Profile
        </a>
        <a class="user-menu-item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 0 1 0 4h-.09"/>
          </svg>
          Settings
        </a>
        <hr class="my-1 border-gray-100" />
        <a class="user-menu-item logout" (click)="logout()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Log out
        </a>
      </div>
    </div>
  </div>
</header>
